// DAO uses this pattern to match what OEAPI is using
export var TIN_LOOSE_PATTERN = /^(?!00)[0-9]{2}[-](?!0000000)[0-9]{7}$/;
// Strict pattern matches only valid first two digit combinations as of 08-Jan-2018 found at the link below
// https://www.irs.gov/businesses/small-businesses-self-employed/how-eins-are-assigned-and-valid-ein-prefixes
export var TIN_STRICT_PATTERN = /^(0[1-6]|1[0-6]|2[0-7]|3[0-9]|4[0-8]|5[0-9]|6[0-8]|7[1-7]|8[0-8]|9[0-58-9])-(?!0000000)[0-9]{7}$/;
export var TIN_CAPTURING_GROUPS = /(\d{2})(\d{7})/;
export var TIN_HYPHEN_PATTERN = /^\d{2}-\d{7}$/;
//# sourceMappingURL=tin.js.map